import React from 'react';
import { useFormContext } from 'react-hook-form';
import { AutocompleteField } from 'components/form';

import { VOFilterCardProps, VOFilters, VOFilterType } from '../../types';

export const ColumnsManager = ({ meta }: VOFilterCardProps) => {
  const { control } = useFormContext<VOFilters>();

  const options = meta?.[VOFilterType.SET_OF_DATA] ?? [];

  return (
    <AutocompleteField
      multiple
      options={options}
      control={control}
      name="SET_OF_DATA"
      disableCloseOnSelect
      disabled={!options.length}
      textFieldProps={{
        size: 'small',
        label: 'Columns',
        variant: 'outlined',
      }}
    />
  );
};
